import { render, staticRenderFns } from "./CustomersCard.vue?vue&type=template&id=2a6076c8&scoped=true"
import script from "./CustomersCard.vue?vue&type=script&lang=js"
export * from "./CustomersCard.vue?vue&type=script&lang=js"
import style0 from "./CustomersCard.vue?vue&type=style&index=0&id=2a6076c8&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6076c8",
  null
  
)

export default component.exports